import { render, staticRenderFns } from "./InitializeCommunityManage.vue?vue&type=template&id=46de63ac&scoped=true"
import script from "./InitializeCommunityManage.vue?vue&type=script&lang=js"
export * from "./InitializeCommunityManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46de63ac",
  null
  
)

export default component.exports